<template>
  
  <div class="excel-import">

    <vs-popup
    @close="closeshowSconfirmPopup"
    :button-close-hidden="true"
    class="holamundo"
    title="Upload Contacts"
    :active.sync="confirmPopup"
  >
    <div class="text-center">
      <h6>
        {{ total_table_rows }} Contacts have been uploaded.  Please check that this is accurate and matches the number of contacts you tried to upload.  If it matches please click proceed.  If it does not you can try and upload again.  


      </h6>
    </div>

          <div class="flex justify-center mt-5">
            <vs-button @click="uploadFileAgain()" class="mr-4">Upload my file again</vs-button>
            <vs-button @click="displayMatchColumns()"  class="ml-4">Proceed with current upload</vs-button>
          </div>


  </vs-popup>

    <div class="mb-8">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Campaign:</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
            :searchOn="'campaign'" @event-name="handleChildEvent"></CampaignAutocomplete>
          <span class="text-danger text-sm mt-5" v-show="campaign_required">{{ campaign_required }}
          </span>
        </div>
      </div>
    
     
    </div>



    <input
      type="file"
      ref="fileInput"
      class="hidden"
      accept=".xlsx, .xls, .csv"
      @change="handleClick"
    />
    <div
      @click="$refs.fileInput.click()"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl"
    >
      <span>{{ upload_file_name }}</span>
      <feather-icon
        icon="UploadCloudIcon"
        svgClasses="h-16 w-16 stroke-current text-grey"
        class="block"
      />
      <span>Drop Excel File or </span>

      <span
        class="font-medium text-primary"
        @click.stop="$refs.fileInput.click()"
        >Browse</span
      >

      
    </div>
    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

  </div>
  
</template>

<script>
import XLSX from "xlsx";
import axios from "@/axios.js";
import ProgressBar from 'vue-simple-progress'
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
export default {
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    purpose: {
      required: true,
      type: String
    }
  },
  components: {
    ProgressBar,
    CampaignAutocomplete

  },
  data() {
    return {
      PLeasewait: '',
      uploaded_column_names : [],
      total_table_rows : 0,
      confirmPopup : false,
      abilities: null,
      campaign_required : null,
      campaignId: null,
      companySearchComponentKey: 0,
      uploadPercentage: 0,
      upload_file_name: null,
      user_id : null,
      user_role : null,
      excelData: {
        header: null,
        results: null,
        meta: null
      }
    };
  },
  watch: {
    uploadPercentage: function(val) {

      this.uploadPercentage = val
     
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
   
  },
  methods: {
    closeshowSconfirmPopup (value) {
      if (!value) this.confirmPopup = true
    },
    uploadFileAgain() {
      this.confirmPopup = false
      this.upload_file_name = null;
      this.uploadPercentage = 0
      this.$refs["fileInput"].value = null;

    },
    displayMatchColumns() {

      this.confirmPopup = false

      let dataToTransfer = {};
      dataToTransfer.uploaded_column_names = this.uploaded_column_names;
      dataToTransfer.campaignId = this.campaignId;
      dataToTransfer.csv_filename = this.upload_file_name;
      this.$emit("dataToTransfer", dataToTransfer);
     
    },
    handleChildEvent() {



let self = this;


let result = moduleCampaignManagement.state.campaign.datas;
self.selected_campaign = result[0];
self.campaignId = self.selected_campaign['id']
self.campaign_required = null;


},
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = "UNKNOWN " + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "Only support uploading one file!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: "Login Attempt",
          text: "Only supports upload .xlsx, .xls, .csv suffix files",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        return false;
      }
      this.uploadFile(rawFile);
    },
    handleClick(e) {

      
      if (!this.selected_campaign) {
        this.campaign_required = "Please select a campaign before uploading a file";
        this.$refs["fileInput"].value = null;

      }else{
        this.uploadPercentage = 0
      this.PLeasewait = "Please wait while we upload your file"
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFile(rawFile);

      }
   
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    importCsvDataToTable(csv_filename) {
      



      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let ObjData = {};
      ObjData.csv_filename = csv_filename
      ObjData.campaign = this.selected_campaign;
      ObjData.user_info = userInfo;

      let self = this;

      axios
        .post(
          this.$base_url + "/api/contacts/import_csv_data_import_contact_to_campaign",
          ObjData,  {
        
            onDownloadProgress: function( progressEvent ) {

            let secondFiftyPercent = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );

            if(secondFiftyPercent == 100){
              this.uploadPercentage = 100
              this.PLeasewait = ''
            }


      }.bind(this)
        })
        .then(response => {


          if (response.data.status == "success" && this.uploadPercentage == 100) {

            self.uploaded_column_names = response.data.data.uploaded_column_names;
            this.total_table_rows = response.data.data.total_table_rows;
            this.confirmPopup = true;

          } else {

            self.$vs.notify({
              color: "danger",
              title: response.data.status,
              text: response.data.message
            });
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    dataBuildimportCsvDataToTable(csv_filename) {
        
  
  
  
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let ObjData = {};
        ObjData.csv_filename = csv_filename
        ObjData.campaign = this.selected_campaign;
        ObjData.user_info = userInfo;
  
        let self = this;
  
        axios
          .post(
            this.$base_url + "/api/contacts/data_build_import_csv_data_import_contact_to_campaign",
            ObjData,  {
          
              onDownloadProgress: function( progressEvent ) {
  
              let secondFiftyPercent = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
  
              if(secondFiftyPercent == 100){
                this.uploadPercentage = 100
                this.PLeasewait = ''
              }
  
  
        }.bind(this)
          })
          .then(response => {
  
  
            if (response.data.status == "success" && this.uploadPercentage == 100) {
  
              self.uploaded_column_names = response.data.data.uploaded_column_names;
              this.total_table_rows = response.data.data.total_table_rows;
              this.confirmPopup = true;
  
            } else {
  
              self.$vs.notify({
                color: "danger",
                title: response.data.status,
                text: response.data.message
              });
            }
            this.$vs.loading.close();
          })
          .catch(error => {
            console.log(error);
          });
      },
    uploadFile(file) {
      this.upload_file_name = file.name;
      let axois_url = this.$base_url + "/api/contacts/upload";
      if (this.purpose == "machine_learning") {
        axois_url =
          this.$base_url + "/api/contacts/upload_with_machine_learning";
      }
      if (this.purpose == "with_company_registration") {
        axois_url =
          this.$base_url + "/api/contacts/upload_with_company_registration";
      }
      if (this.purpose == "import_contacts") {
        axois_url = this.$base_url + "/api/contacts/import";
      }
      if (this.purpose == "data_build_import_contact_to_campaign") {
              axois_url = this.$base_url + "/api/contacts/data_build_upload_csv_to_campaign";
      }
      if (this.purpose == "import_contact_to_campaign") {
        axois_url = this.$base_url + "/api/contacts/upload_csv_to_campaign";
      }
      let formData = new FormData();
      formData.append("file", file);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: function( progressEvent ) {

            let firstFiftyPercent = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );

          



            if(firstFiftyPercent == 100){
              this.uploadPercentage = 50
            }


      }.bind(this)
        })
        .then(response => {
          if (response.data.status == "success") {
            if (response.data.data) {
                   let csv_filename = response.data.data;



 if (this.purpose == "data_build_import_contact_to_campaign") {
                  this.dataBuildimportCsvDataToTable(csv_filename)
                }
                else{
                  this.importCsvDataToTable(csv_filename)
                }

              // this.onSuccess && this.onSuccess(this.excelData);
            }
          }
        })
        .catch(function(ee) {
          console.log(ee)
          console.log("FAILURE!!");
        });
       // fix can't select the same excel
      
    }
  }
};
</script>
